import styled from 'styled-components';
import PropTypes from 'prop-types';

const FlexBar = styled.div`
  display: flex;
  ${props => (props.vertical ? 'height' : 'width')}: 100%;
  flex-wrap: nowrap;
  flex-direction: ${props => (props.vertical ? 'column' : 'row')};
  align-items: ${props => (props.alignItems ? props.alignItems : 'center')};
  padding: ${props => (props.padding || '10px')};
  margin: 0;
  ${props => (props.applyBackgroundColor ? 'background: ' + props.theme.backgroundColor : '')}
`;

FlexBar.propTypes = { applyBackgroundColor: PropTypes.bool };

FlexBar.defaultProps = { applyBackgroundColor: false };

export default FlexBar;
